/** Filipino translations, keyed by the English text. Keep sentences short and natural. */
export const FIL: Record<string, string> = {
  'Continue': 'Magpatuloy',
  'Cancel': 'Kanselahin',
  'Save': 'I-save',
  'Back': 'Bumalik',
  'Done': 'Tapos',
  'Loading…': 'Naglo-load…',
  'Something went wrong. Try again.': 'May mali. Subukan ulit.',
  'Retry': 'Ulitin',
  'Yes': 'Oo',
  'No': 'Hindi',
  'Edit': 'I-edit',
  'Remove': 'Alisin',
  'Close': 'Isara',
  'Required': 'Kailangan',
  'Optional': 'Opsyonal',
  'Help': 'Tulong',
  'Language': 'Wika',
  'Sign out': 'Mag-sign out',
  'Main': 'Pangunahin',
  'A new version of LGU Aid is ready. Tap to update.': 'May bagong bersyon ng LGU Aid. I-tap para mag-update.',
  // Core screens (sign-in, shells, card page, merchant sales)
  'This browser cannot share your location.': 'Hindi maibahagi ng browser na ito ang lokasyon mo.',
  'Location is off. Move the pin by tapping the map.': 'Naka-off ang lokasyon. I-tap ang mapa para ilipat ang pin.',
  'Use my location': 'Gamitin ang lokasyon ko',
  'Tap the map to place the pin on your gate.': 'I-tap ang mapa para ilagay ang pin sa inyong pinto.',
  'Office': 'Opisina',
  'To add invoice numbers, void or refund, open this page on a registered POS device.': 'Para maglagay ng invoice number, mag-void o mag-refund, buksan ang page na ito sa rehistradong POS device.',
  'Devices': 'Mga device',
  'Reference': 'Reference',
  'Time': 'Oras',
  'Assistance': 'Ayuda',
  'Cash': 'Cash',
  'Completed': 'Tapos na',
  'Missing': 'Wala pa',
  'My store': 'Aking tindahan',
  'Accreditation {no}': 'Akreditasyon {no}',
  'Authenticator code': 'Code ng authenticator',
  'Open your authenticator app and enter the 6-digit code. Lost your phone? Enter one of your recovery codes.': 'Buksan ang authenticator app at ilagay ang 6-digit code. Nawala ang phone? Ilagay ang isa sa recovery codes mo.',
  'Verify': 'I-verify',
  'For LGU staff and accredited merchants. Constituents use their card and PIN at the store.': 'Para sa LGU staff at akreditadong tindahan. Ang mga constituent ay gumagamit ng card at PIN sa tindahan.',
  'Forgot your password? Ask your administrator (LGU staff) or your store owner (cashiers).': 'Nakalimutan ang password? Magtanong sa administrator (LGU staff) o sa may-ari ng tindahan (cashier).',
  'Store owner? Apply for accreditation': 'May-ari ng tindahan? Mag-apply para sa akreditasyon',
  'Where can I use my card?': 'Saan ko magagamit ang card ko?',
  'Choose your password': 'Pumili ng password',
  '{name}, replace the temporary password with your own. You will then sign in again.': '{name}, palitan ang pansamantalang password ng sarili mong password. Pagkatapos, mag-sign in ulit.',
  'New password': 'Bagong password',
  'New password again': 'Bagong password ulit',
  'Save password': 'I-save ang password',
  'Save your recovery codes': 'I-save ang recovery codes mo',
  'Each code works once if you lose your phone. They are shown only now. Keep them somewhere safe, away from your phone.': 'Isang beses lang gagana ang bawat code kapag nawala ang phone mo. Ngayon lang ito ipapakita. Itago sa ligtas na lugar, malayo sa phone mo.',
  'I saved them': 'Na-save ko na',
  'Set up two-step sign-in': 'I-set up ang two-step sign-in',
  'Your role can approve, pay or manage, so it needs an authenticator app (Google Authenticator, Microsoft Authenticator…). It takes a minute.': 'Ang role mo ay nag-aapruba, nagbabayad o nagma-manage, kaya kailangan ng authenticator app (Google Authenticator, Microsoft Authenticator…). Isang minuto lang.',
  'Start set-up': 'Simulan',
  'Scan with your authenticator': 'I-scan gamit ang authenticator',
  'Scan the code, then enter the 6 digits the app shows.': 'I-scan ang code, pagkatapos ilagay ang 6 na numerong ipinapakita ng app.',
  'QR code for your authenticator app': 'QR code para sa authenticator app',
  '6-digit code': '6-digit code',
  'Turn on': 'I-on',
  'This is an LGU assistance card. It works only at accredited stores, with the owner\'s PIN.': 'Ito ay assistance card ng LGU. Gumagana lang ito sa akreditadong tindahan, gamit ang PIN ng may-ari.',
  'Found this card? Please return it to the LGU office.': 'Nakita mo ang card na ito? Pakibalik sa opisina ng LGU.',
  'Lost card hotline': 'Hotline para sa nawalang card',
};
